module.exports = __webpack_public_path__ + "img/KONCILI_LOGO.7cd49c63.png";